import { Component, OnInit } from '@angular/core';
import {GoBaseComponent} from "../go-base.component";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {UI_TEXTS} from "../../../enums/e-texts";

@Component({
  selector: 'go-move',
  templateUrl: './go-move.component.html',
  styles: []
})
export class GoMoveComponent extends GoBaseComponent {
  UI_TEXTS = UI_TEXTS;

  constructor() {
    super(GO_COMPONENTS.MOVE);
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-move/go-move.component.ts